export const dspLogin = {
  request: 'dsp/dsp_login_request',
  success: 'dsp/dsp_login_success',
  failure: 'dsp/dsp_login_failure',
};
